<template>
  <el-dialog v-model="dialogVisible" title="修改收货地址" width="480px">
    <el-form ref="formRef" v-loading="formLoading" :model="formData" label-width="100px">
      <el-form-item label="收件人">
        <el-input v-model="formData.receiverName" placeholder="请输入收件人名称" />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="formData.receiverMobile" placeholder="请输入收件人手机号" />
      </el-form-item>
      <el-form-item label="所在地">
        <el-tree-select
          v-model="formData.receiverAreaId"
          :data="areaList"
          :props="defaultProps"
          :render-after-expand="true"
          class="!w-full"
        />
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input
          v-model="formData.receiverDetailAddress"
          :rows="3"
          placeholder="请输入收件人详细地址"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确定</el-button>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import * as MerchantOrderApi from '@/api/merchant/order'
import { getAreaTree } from '@/api/merchant/system/area'
import { copyValueToTarget } from '@/utils'
import { defaultProps } from '@/utils/tree'

defineOptions({ name: 'MerchantOrderUpdateAddressForm' })

const message = useMessage()

const dialogVisible = ref(false)
const formLoading = ref(false)
const formData = ref({
  id: undefined as number | undefined,
  receiverName: '',
  receiverMobile: '',
  receiverAreaId: null as number | null,
  receiverDetailAddress: ''
})
const areaList = ref([])
const formRef = ref()

const open = async (row: any) => {
  resetForm()
  copyValueToTarget(formData.value, row)
  dialogVisible.value = true
}
defineExpose({ open })

const emit = defineEmits(['success'])
const submitForm = async () => {
  formLoading.value = true
  try {
    const data = unref(formData)
    await MerchantOrderApi.updateAddress({
      id: data.id!,
      receiverName: data.receiverName,
      receiverMobile: data.receiverMobile,
      receiverAreaId: data.receiverAreaId!,
      receiverDetailAddress: data.receiverDetailAddress
    })
    message.success('地址已更新')
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    receiverName: '',
    receiverMobile: '',
    receiverAreaId: null,
    receiverDetailAddress: ''
  }
  formRef.value?.resetFields()
}

onMounted(async () => {
  areaList.value = (await getAreaTree()) || []
})
</script>
